/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _omit = _interopDefault(require('lodash/fp/omit'));
var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var TileWMSSource = __ol.source.TileWMS;
var props = {
  extParams: Object, // Additional WMS Request params
  gutter: Number,
  hidpi: Boolean,
  layers: {
    type: String,
    required: true
  },
  serverType: String,
  styles: String, // WMS Request styles
  version: {
    type: String,
    default: core.WMS_VERSION
  },
  url: {
    type: String,
    required: true
  }
};

var upperCase = function upperCase(x) {
  return x.toUpperCase();
};
var keysToUpperCase = function keysToUpperCase(x) {
  return _Object$keys(x).map(upperCase);
};
var cleanExtParams = function cleanExtParams(params) {
  return _omit(['LAYERS', 'VERSION', 'STYLES'], keysToUpperCase(params));
};

var methods = {
  /**
   * @returns {ol.source.TileWMS}
   * @protected
   */
  createSource: function createSource() {
    return new TileWMSSource({
      attributions: this.attributions,
      cacheSize: this.cacheSize,
      params: _extends({}, cleanExtParams(this.extParams), {
        LAYERS: this.layers,
        STYLES: this.styles,
        VERSION: this.version
      }),
      crossOrigin: this.crossOrigin,
      gutter: this.gutter,
      hidpi: this.hidpi,
      logo: this.logo,
      tileGrid: this._tileGrid,
      projection: this.projection,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      serverType: this.serverType,
      wrapX: this.wrapX,
      url: this.urlTmpl
    });
  },

  /**
   * @param {number[]} coordinate
   * @param {number} [resolution]
   * @param {string} [projection]
   * @param {Object} [params] GetFeatureInfo params. `info_format` at least should be provided.
   *                          If `query_layers` is not provided then the layers specified in the `layers` prop will be used.
   *                          `version` should not be specified here (value from `version` prop will be used).
   * @return {string|undefined}
   */
  getFeatureInfoUrl: function getFeatureInfoUrl(coordinate, resolution, projection) {
    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    core.assert.hasView(this);
    core.assert.hasSource(this);

    resolution || (resolution = this.$view.getResolution());
    projection || (projection = this.projection);

    return this.$source.getFeatureInfoUrl(coordinate, resolution, projection, cleanExtParams(params));
  }
};

var watch = {
  layers: function layers(LAYERS) {
    this.$source && this.$source.updateParams({ LAYERS: LAYERS });
  },
  version: function version(VERSION) {
    this.$source && this.$source.updateParams({ VERSION: VERSION });
  },
  styles: function styles(STYLES) {
    this.$source && this.$source.updateParams({ STYLES: STYLES });
  },
  extParams: function extParams(value) {
    this.$source && this.$source.updateParams(cleanExtParams(value));
  }
};

var Source = {
  name: 'vl-source-wms',
  mixins: [core.tileSource],
  props: props,
  methods: methods,
  watch: watch
};

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/wms-source/index.js
// module id = 1204
// module chunks = 1